import 'whatwg-fetch'

import { setFinished, setInitial, setLoading } from './LoadingButton'

export default () => {
    const forms = document.querySelectorAll('.js-form')

    if (forms) {
        ;[...forms].forEach(form => {
            form.addEventListener('submit', e => {
                e.preventDefault()

                const button = form.querySelector('.c-button')

                setLoading(button) // Set button to loading

                if (!form.checkValidity()) return

                sendForm(form).then(handleFetch).then(r => {
                    if (r.error) {
                        setInitial(button)
                        return
                    }
                    setFinished(button)
                    setTimeout(() => {
                       if (typeof r.no_redirect !== 'undefined' && r.no_redirect == 'true') {
                            form.querySelectorAll('div:not(.success)').
                                forEach((el) => {
                                    el.style.display = 'none'
                                })

                            form.querySelectorAll('div.alert.success').
                                forEach((el) => {
                                    el.style.display = 'block'
                                })
                        } else if (typeof r.action !== 'undefined') {
                            window.location = r.action
                        }

                        setInitial(button)
                        resetForm(form)
                    }, 1000)
                }).catch(e => {
                    setInitial(button)
                    window.alert(
                        'Het formulier is niet verzonden, dit kan komen doordat het bijgevoegde bestand te groot is. Probeer het opnieuw.',
                    )
                })
            })
        })
    }

    const sendForm = form =>
        window.fetch((typeof window.site.vars.base_url !== 'undefined'
            ? window.site.vars.base_url
            : '') + '/wordpress/wp-admin/admin-ajax.php?action=send_form', {
            credentials: 'same-origin',
            method: 'post',
            body: new window.FormData(form),
        })

    const resetForm = form => form.reset()

    const handleFetch = r => {
        if (!r.ok) {
            const error = {
                error:
                    'Kan formulier niet versturen. Probeer het a.u.b. opnieuw of neem contact met ons op.',
            }
            return error
        } else {
            return r.json()
        }
    }
}

window.fillForm = () => {
    const forms = document.querySelectorAll('form')
    if (!forms) return
        ;
    [...forms].forEach(form => {
        const inputs = form.querySelectorAll('.c-input__input')
        ;[...inputs].forEach(input => {
            const { type, required, name } = input
            if (required === true) {
                if (type === 'text') {
                    input.value = `BRIGHT TEST ${Math.random().
                        toString(36).
                        substring(7)}`
                } else if (type === 'email') {
                    input.value = 'TEST@TEST.COM'
                } else if (type === 'tel') {
                    input.value = '06-12345678'
                } else if (name === 'message') {
                    input.value = 'Message'
                }
            }
        })
    })
}

// WEBPACK FOOTER //
// ./src/js/modules/SendForm.js
